

export const menu = [
  {
    text: 'Administration', heading: true, roles: ['SUPER_ADMIN']
  },
  {
    text: 'Equipes', link: '/backoffice/equipes', icon: 'fas fa-users-cog',
    roles: ['SUPER_ADMIN'],
  },
  {
    text: 'Gestion des utilisateurs', link: '/backoffice/users', icon: 'fas fa-users',
    roles: ['SUPER_ADMIN'],
  },
  {
    text: 'Pointage', link: '/backoffice/pointage', icon: 'far fa-clock',
    roles: ['SUPER_ADMIN', 'RESPONSABLE_HR'],
  },
  {
    text: 'Calo', heading: true,
    roles: ['SUPER_ADMIN', 'BACKOFFICE', 'MANAGER', 'AGENT', 'RESPONSABLE_PROD']
  },
  {
    text: 'Dashboards Calo',  link: '/backoffice/dashboard-calo', icon: 'fas fa-chart-line',
    roles: ['SUPER_ADMIN', 'MANAGER', 'RESPONSABLE_PROD', 'AGENT'],
  },
  {
    text: 'Fiche Commerciale', link: '/backoffice/fiche-commercial', icon: 'icon-notebook',
    roles: ['SUPER_ADMIN', 'BACKOFFICE', 'MANAGER', 'AGENT', 'RESPONSABLE_PROD'],
  },
  {
    text: 'Recherche avancée FC', link: '/backoffice/search-fiche-commercial', icon: 'fa fa-search',
    roles: ['SUPER_ADMIN'],
  },
  {
    text: 'Agenda', link: '/backoffice/agenda', icon: 'fas fa-calendar-alt',
    roles: ['SUPER_ADMIN', 'BACKOFFICE', 'AGENT', 'TECHNICIEN', 'MANAGER', 'RESPONSABLE_PROD'],
  },
  {
    text: 'Energy', heading: true,
    roles: ['SUPER_ADMIN', 'E_VENDEUR', 'E_AGENT', 'E_MANAGER', 'E_RESPONSABLE_PROD', 'E_QUALITE']
  },
  {
    text: 'Dashboards Energy',  link: '/backoffice/dashboard-energy', icon: 'fas fa-chart-line',
    roles: ['SUPER_ADMIN', 'E_VENDEUR', 'E_AGENT', 'E_MANAGER', 'E_RESPONSABLE_PROD', 'E_QUALITE']
  },
  {
    text: 'Dashboard V2',  link: '/backoffice/dashboard-energy-v2', icon: 'fas fa-table',
    roles: ['SUPER_ADMIN', 'E_VENDEUR', 'E_AGENT', 'E_MANAGER', 'E_RESPONSABLE_PROD', 'E_QUALITE']
  },
  {
    text: 'Fiche Commerciale', link: '/backoffice/fiche-commercial-energy', icon: 'icon-energy',
    roles: ['SUPER_ADMIN', 'E_VENDEUR', 'E_AGENT', 'E_MANAGER', 'E_RESPONSABLE_PROD', 'E_QUALITE']
  },
  {
    text: 'Recherche avancée', link: '/backoffice/search-fiche-commercial-energy', icon: 'fa fa-search',
    roles: ['SUPER_ADMIN', 'E_VENDEUR', 'E_AGENT', 'E_MANAGER', 'E_RESPONSABLE_PROD', 'E_QUALITE'],
  }/*
  {
    text: 'CPF', heading: true,
    roles: ['SUPER_ADMIN', 'F_FORMATEUR', 'F_VENDEUR', 'F_AGENT', 'F_MANAGER', 'F_RESPONSABLE_PROD', 'F_QUALITE']
  },
  {
    text: 'Fiche Commerciale', link: '/backoffice/fiche-commercial-cpf', icon: 'fas fa-school',
    roles: ['SUPER_ADMIN', 'F_FORMATEUR', 'F_VENDEUR', 'F_AGENT', 'F_MANAGER', 'F_RESPONSABLE_PROD', 'F_QUALITE']
  },
  {
    text: 'CRM Tools', heading: true, roles: ['*']
  },
  {
    text: 'MailBox BDF', link: '/backoffice/mailbox', icon: 'fa fa-inbox',
    roles: ['*'],
  }*/
];

//E_VENDEUR, E_AGENT, E_MANAGER, E_RESPONSABLE_PROD, E_QUALITE
